import HiddenTypography from 'components/hidden-typography/hidden-typography.component';
import { useTranslation } from 'react-i18next';
import { selectDisplayOrderSubTotal } from 'redux/cart/cart.selectors';
import { useReduxSrAlert } from '../sr-alerts.hooks';

const SrCartSubtotalAlert = () => {
  const { t } = useTranslation();
  const alertMessage = useReduxSrAlert(
    selectDisplayOrderSubTotal,
    totalOrderSubTotal =>
      t('orderSubtotalSrAlert', { cartTotal: totalOrderSubTotal }),
  );

  return <HiddenTypography role="alert">{alertMessage}</HiddenTypography>;
};
export default SrCartSubtotalAlert;
